import { IComplex } from 'src/typings/complexes';

import { getComplexDataByGetParams } from 'src/api';
import { useGetAuthData } from 'src/hooks/use-get-auth-data';
import { useQuery } from '@tanstack/react-query';
import { QueryResponseProps } from 'src/typings/reactQueryResponce';

export const useGetComplexes = (userId: number | undefined, page: number, options: string) => {
  const { getJWT } = useGetAuthData();
  const jwt = getJWT();

  return useQuery({
    queryKey: ['complexes', options, userId, page],
    queryFn: async (): Promise<QueryResponseProps<IComplex[]> | null> => {
      if (!userId) return null;
      const { data } = await getComplexDataByGetParams(jwt, `${options}&page=${page}`);
      return {
        itemsPerPage: data['hydra:itemsPerPage'],
        totalItems: data['hydra:totalItems'],
        hydraView: data['hydra:view'],
        members: data['hydra:member'],
      };
    },
    enabled: !!userId,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
  });
};
